export const formatWeightLabel = (weight?: number | null) => {
  if (typeof weight === 'undefined' || weight === null) {
    return '-';
  }

  const numWeight = Number(weight);

  if (isNaN(numWeight)) {
    return '-';
  }

  return `${Number(numWeight.toFixed(2))}g`;
};
